import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Tooltip,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { RiDeleteBinLine, RiEdit2Line, RiMessage3Line } from "@remixicon/react";
import { useState } from "react";
import DelModal from "./delModal";
import EditModal from "./editModal";
import { useSelector } from "react-redux";
import { selectUser } from "@/reducer/userslice";
import { ChatTopic } from "@/types/writing";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectCurrentTopic, setCurrentTopic } from "@/reducer/chatSlice";
import { getChatMsgs } from "@/services/api/thunks/chat";

type Props = {
  chatRoomInfo: ChatTopic;
};

const MeetingListItem = (props: Props) => {
  const dispatch = useAppDispatch();
  const { chatRoomInfo } = props;
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const editControl = useDisclosure();
  const delControl = useDisclosure();
  const user = useSelector(selectUser);
  const currentTopic = useAppSelector(selectCurrentTopic);
  const sessionId = currentTopic.id;
  const toast = useToast();
  
  const handleOpenEdit = () => {
    editControl.onOpen();
  };

  const handleOpenDel = () => {
    delControl.onOpen();
  };

  const handleChangeChatTopic = async () => {
    if (user && user.id) {
      dispatch(setCurrentTopic(chatRoomInfo));
      dispatch(getChatMsgs(chatRoomInfo.id))
    } else {
      toast({ title: "请登录系统", position: "top", status: "error", duration: 1000 });
    }
    
  }

  return (
    <Flex
      w="100%"
      h="46px"
      borderWidth = "1px"
      borderColor={chatRoomInfo.id === sessionId ? "#496AE1" : "#e0e0e6"}
      borderRadius="4px"
      justifyContent={"space-between"}
      alignItems="center"
      mt="15px"
      pl="10px"
      pr="10px"
      color={chatRoomInfo.id === sessionId ? "#496AE1" : "#27314D"}
      bg={chatRoomInfo.id === sessionId ? "#EDF2F7" : "none"}
      fontSize={"14px"}
      cursor="pointer"
      onMouseOver={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      _hover={{
        color: "#496AE1",
        borderColor: "#496AE1",
        bg: "#EDF2F7",
      }}
      onClick={handleChangeChatTopic}
    >
      <Flex alignItems="center">
        <Icon w="14px" minW={"14px"} h="14px" mr="10px" as={RiMessage3Line} />
        <Text>{chatRoomInfo.title}</Text>
      </Flex>
      {isHovered && (
        <Box>
          <IconButton
            w="14px"
            h="14px"
            minW={"14px"}
            aria-label="编辑"
            variant={"unstyle"}
            color={"#496AE1"}
            icon={<RiEdit2Line />}
            mr="5px"
            onClick={handleOpenEdit}
          />
          <IconButton
            w="14px"
            minW={"14px"}
            h="14px"
            aria-label="删除"
            variant={"unstyle"}
            color={"#496AE1"}
            icon={<RiDeleteBinLine />}
            onClick={handleOpenDel}
          />
        </Box>
      )}

      {/* 修改会话名称*/}
      <EditModal
        isOpen={editControl.isOpen}
        onClose={editControl.onClose}
        editInfo={chatRoomInfo}
      />

      {/* 删除会话*/}
      <DelModal
        isOpen={delControl.isOpen}
        onClose={delControl.onClose}
        editInfo={chatRoomInfo}
      />
    </Flex>
  );
};

export default MeetingListItem;
